export const CATEGORY_SEPARATOR = ",";
export const ITEM_KEY_CATEGORY_SEPARATOR = "__";
export const ITEM_KEY_COUNTER_SEPARATOR = "@";
